import { render, staticRenderFns } from "./NotAuthorizedPage.vue?vue&type=template&id=606ffec4&"
import script from "./NotAuthorizedPage.vue?vue&type=script&lang=js&"
export * from "./NotAuthorizedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports